import { useEffect } from 'react'
import { useTranslation } from '@front/model'
import { showNotification } from '@mantine/notifications'

export const useToastError = (error: string | undefined): void => {
  const { t } = useTranslation()

  useEffect(() => {
    if (error)
      showNotification({
        title: t('Error'),
        message: error,
        color: 'red',
        autoClose: 5000,
      })
  }, [error, t])
}
